export function EmptyState() {
  return (
    <div className="text-center py-12 px-4">
      <div className="text-6xl mb-4">⭐</div>
      <h3 className="text-xl font-semibold mb-2 text-white">Your plan is empty!</h3>
      <p className="text-gray-400">
        Go star some sessions to build your personalized agenda.
      </p>
    </div>
  )
} 